import { RestResponse } from "@/business/shared/commons/rest/RestResponse";
import { restClient } from "@/business/shared/commons/rest/restClient";
import { cancelPaymentUrl } from "../constants/urls";
import { getEnvVariable } from "@/business/shared/commons/envUtils/getEnvVariable";
import { CancelPaymentRequest } from "../../domain/payment";
import { DaccachErrorActions } from "@/business/shared/commons/DaccachError";

export const cancelPaymentService = {
  async execute(token: string, request: CancelPaymentRequest): Promise<void> {
    const url = getEnvVariable
      .execute("VUE_APP_DACCACH_URL")
      .concat(cancelPaymentUrl);

    const headers = {
      "web-token": token,
      Accept: "application/json",
      "Content-Type": "application/json",
    };

    const response: RestResponse = await restClient().sendRequest(
      url,
      "POST",
      JSON.stringify(request),
      headers
    );

    if (!response.isSuccess) {
      const errorMessage =
        response.statusCode == 422
          ? DaccachErrorActions().extractFormError(response.content)
          : response.content;
      throw DaccachErrorActions().createError(errorMessage);
    }
  },
};
